import React, { useEffect, useState } from "react";
import { fetchNewsletter } from "../../utils/fetch"; // Asegúrate de que la función está importada correctamente
import "./newsletter.scss";
import DynamicCommonLoader from "../../components/common-loader/dynamicCommonLoader";
import logo from "../../assets/img/newsletter_desktop.png";

const NewsletterPage = () => {
  const [loader, setLoader] = useState(true);
  const [newsletters, setNewsletters] = useState([]);
  const [selectedNewsletterUrl, setSelectedNewsletterUrl] = useState(null);

  useEffect(() => {
    const getNewsletters = async () => {
      try {
        const response = await fetchNewsletter("FileUpload/publicaciones", "GET");
        // Filtrar los newsletters habilitados
        console.log(response.data);
        const enabledNewsletters = response.data.filter(n => n.isEnabled);
        setNewsletters(enabledNewsletters);
      } catch (error) {
        console.error("Error al obtener los newsletters", error);
      } finally {
        setLoader(false); // Desactivar el loader cuando finalice la petición
      }
    };

    getNewsletters();
  }, []);

  // Función para extraer el nombre del mes y año desde "nombreArchivo"
  const getMonthAndYear = (nombreArchivo) => {
    const [month, year] = nombreArchivo.split("_"); // Ej: "Enero_2023.html" retorna ["Enero", "2023.html"]
    return `${month} ${year.split(".")[0]}`; // Retorna "Enero 2023"
  };

  return (
    <>
      {loader ? (
        <DynamicCommonLoader dynamic={"225px"} />
      ) : (
        <section className="bg-novedades">
          <div className="container">
            <div className="row pt-5 pb-3">
              <div className="col-lg-12">
                <h2 className="global_title bold">Newsletters</h2>
                <hr className="hr6 w-50" />
              </div>
            </div>

            {selectedNewsletterUrl ? (
              <div className="row">
                <div className="col-12 mb-3 text-end">
                  <button
                    className="btn btn-danger"
                    onClick={() => setSelectedNewsletterUrl(null)}
                  >
                    Cerrar
                  </button>
                </div>
                <div className="col-12">
                  <div className="iframe-container" style={{ height: "800px", border: "1px solid #ccc" }}>
                    <iframe
                      src={selectedNewsletterUrl}
                      title="Newsletter"
                      width="100%"
                      height="100%"
                      frameBorder="0"
                    ></iframe>
                  </div>
                </div>
              </div>
            ) : (
              <div className="row">
                {newsletters.map((newsletter) => (
                  <div className="col-lg-4 mb-4" key={newsletter.id}>
                    <div
                      className="card b-radius-10 p-2 card-novedades border-green border-20 widht cursor-pointer"
                      onClick={() => setSelectedNewsletterUrl(newsletter.url)}
                    >
                      <div className="card-body">
                        <img
                          src={logo}
                          alt="Newsletter"
                          className="w-100"
                        />
                      </div>
                      <div className="card-footer d-flex bg-transparent border-0 justify-content-start">
                        <p>
                          <strong>
                            <span>{getMonthAndYear(newsletter.nombreArchivo)}</span>
                          </strong>
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      )}
    </>
  );
};

export default NewsletterPage;
